import { type Component, defineAsyncComponent } from "vue";

import type { DraftBulkAction } from "./types";

interface ComponentProps {
  action: unknown;
}

const components: Record<DraftBulkAction["type"], Component<ComponentProps>> = {
  add_notes: defineAsyncComponent(() => import("./actions/AddNotesAction.vue")),
  apply_tags: defineAsyncComponent(
    () => import("./actions/ApplyTagsAction.vue")
  ),
  ban_subscribers: defineAsyncComponent(
    () => import("./actions/BanSubscribersAction.vue")
  ),
  delete_inbox_items: defineAsyncComponent(
    () => import("./actions/DeleteInboxItemsAction.vue")
  ),
  delete_comments: defineAsyncComponent(
    () => import("./actions/DeleteCommentsAction.vue")
  ),
  mark_comments_as_active: defineAsyncComponent(
    () => import("./actions/MarkCommentsAsActiveAction.vue")
  ),
  mark_comments_as_spammy: defineAsyncComponent(
    () => import("./actions/MarkCommentsAsSpammyAction.vue")
  ),
  delete_emails: defineAsyncComponent(
    () => import("./actions/DeleteEmailsAction.vue")
  ),
  delete_subscribers: defineAsyncComponent(
    () => import("./actions/DeleteSubscribersAction.vue")
  ),
  delete_surveys_responses: defineAsyncComponent(
    () => import("./actions/DeleteSurveysResponsesAction.vue")
  ),
  delete_surveys: defineAsyncComponent(
    () => import("./actions/DeleteSurveysAction.vue")
  ),
  delete_tags: defineAsyncComponent(
    () => import("./actions/DeleteTagsAction.vue")
  ),
  change_tags_color: defineAsyncComponent(
    () => import("./actions/ChangeTagsColorAction.vue")
  ),
  gift_subscribers: defineAsyncComponent(
    () => import("./actions/GiftSubscribersAction.vue")
  ),
  cancel_stripe_subscriptions: defineAsyncComponent(
    () => import("./actions/CancelStripeSubscriptionsAction.vue")
  ),
  modify_stripe_subscriptions: defineAsyncComponent(
    () => import("./actions/ModifyStripeSubscriptionsAction.vue")
  ),
  pause_stripe_subscriptions: defineAsyncComponent(
    () => import("./actions/PauseStripeSubscriptionsAction.vue")
  ),
  reactivate_subscribers: defineAsyncComponent(
    () => import("./actions/ReactivateSubscribersAction.vue")
  ),
  rename_metadata: defineAsyncComponent(
    () => import("./actions/RenameMetadataAction.vue")
  ),
  replay_external_events: defineAsyncComponent(
    () => import("./actions/ReplayExternalEventsAction.vue")
  ),
  resubscribe_subscribers: defineAsyncComponent(
    () => import("./actions/ResubscribeSubscribersAction.vue")
  ),
  send_email: defineAsyncComponent(
    () => import("./actions/SendEmailAction.vue")
  ),
  send_reminder: defineAsyncComponent(
    () => import("./actions/SendReminderAction.vue")
  ),
  unban_subscribers: defineAsyncComponent(
    () => import("./actions/UnbanSubscribersAction.vue")
  ),
  unflag_subscribers: defineAsyncComponent(
    () => import("./actions/UnflagSubscribersAction.vue")
  ),
  ungift_subscribers: defineAsyncComponent(
    () => import("./actions/UngiftSubscribersAction.vue")
  ),
  unsubscribe_subscribers: defineAsyncComponent(
    () => import("./actions/UnsubscribeSubscribersAction.vue")
  ),
  update_emails_type: defineAsyncComponent(
    () => import("./actions/UpdateEmailsTypeAction.vue")
  ),
  update_surveys_status: defineAsyncComponent(
    () => import("./actions/UpdateSurveysStatusAction.vue")
  ),
};

export default components;
